
import axios from 'axios';
import { instance2, apiClient, errorHandler } from './http';
import * as Constants from "../utils/constants"
import { getLocalStorage, setLocalStorage } from '../utils/localStorageUtils';

const FieldService = (data) =>{
    
    const response = instance2.post('/fields/create',data).then(
        response  =>{
          return response.data;
        }
    ).catch(error=>{
       
        return error;
     });
     return response;
}

const Fieldgroup = (data) =>{

    const response = instance2.post('/fieldgroups/create',data).then(
        response  =>{
          return response.data;
        }
    ).catch(error=>{
        return error
     });
     return response;
}

const generateToken = async () => {
  try {
    const response = await instance2.get('/sentinel/refresh-token');
    const { access_token, expires_in } = response.data.resultObject;
    const expiryTime = Date.now() + expires_in * 1000; 
    setLocalStorage('accessToken', access_token);
    setLocalStorage('expiresAt', expiryTime.toString());
    return access_token;
  } catch (error) {
    throw new Error('Unable to generate token');
  }
};
  
  const getToken = async () => {
    const token = getLocalStorage('accessToken');
    const expiresAt: string = getLocalStorage('expiresAt');
    if (!token || Date.now() >= parseInt(expiresAt)) {
      return await generateToken();
    }
    return token;
  };


const Fieldstats = (data:any) =>{

    const response = apiClient.post('/v1/statistics',data).then(
        response  =>{
          return response;
        }
    ).catch(error=>{
        return error;
     });
     return response;
}


const FieldgroupgetAll = () =>{
    const response = instance2.get('/fieldgroups/getAll').then(
        response  =>{
          return response?.data;
        }
    ).catch(error=>{
      return error;
     });
     return response;
}


const Fieldname = (data) =>{

    var fieldId = {
        value : data
    };

    const response = instance2.post('/fields/getAll', fieldId).then(
        response  =>{
          return response.data;
        }
    ).catch(error=>{
      return error;
});
     return response;
}

const FieldState = (data) =>{


    var fieldId = {
        value : data
    }; 

    const response = instance2.post('/fields/getbyFieldId',fieldId).then(
    response  =>{
        return response?.data;
    }
    ).catch(error=>{
        return error;
    });

    

     return response;
}

const FieldDelete = (data : any) =>{
   const response = instance2.delete('/fields/'+data).then(response=>{
        return response
    }).catch(error=>{
        return error.response.data
    })

    return response;
}

const getWeatherData = (lat,lon) => {
  const response = axios.get(`https://api.openweathermap.org/data/2.5/weather?appid=${process.env.WEATHER_API_TOKEN}&lat=${lat}&lon=${lon}&units=metric`).then((response) => response)
  return response
}

export const fieldService = {
    FieldService,Fieldgroup,FieldgroupgetAll,Fieldstats,Fieldname,FieldState,FieldDelete, getToken, getWeatherData,
}